import React, { useState } from 'react';
import { FaHospital, FaCar, FaHome, FaShieldAlt } from 'react-icons/fa';
import './Insurance.css';

const Insurance = () => {
  const [activeTab, setActiveTab] = useState('health');
  const [selectedPlan, setSelectedPlan] = useState(null);

  const insuranceTypes = [
    { id: 'health', name: 'Health Insurance', icon: <FaHospital /> },
    { id: 'auto', name: 'Auto Insurance', icon: <FaCar /> },
    { id: 'home', name: 'Home Insurance', icon: <FaHome /> },
    { id: 'life', name: 'Life Insurance', icon: <FaShieldAlt /> },
  ];

  const insurancePlans = {
    health: [
      { id: 1, name: 'Basic Health', price: 89, coverage: 'Essential medical coverage', features: ['Doctor visits', 'Emergency care', 'Generic drugs'] },
      { id: 2, name: 'Premium Health', price: 149, coverage: 'Comprehensive medical coverage', features: ['Specialist visits', 'Hospital stays', 'Brand drugs', 'Dental & vision'] },
      { id: 3, name: 'Family Health', price: 299, coverage: 'Whole family protection', features: ['All Premium features', 'Child care', 'Maternity', 'Preventive care'] },
    ],
    auto: [
      { id: 1, name: 'Liability Only', price: 45, coverage: 'Basic legal requirements', features: ['Bodily injury', 'Property damage', 'Uninsured motorist'] },
      { id: 2, name: 'Standard Coverage', price: 89, coverage: 'Enhanced protection', features: ['Collision', 'Comprehensive', 'Rental reimbursement'] },
      { id: 3, name: 'Full Protection', price: 129, coverage: 'Complete peace of mind', features: ['All Standard features', 'Roadside assistance', 'Gap coverage'] },
    ],
    home: [
      { id: 1, name: 'Dwelling Protection', price: 59, coverage: 'Basic structure coverage', features: ['Fire damage', 'Theft protection', 'Weather damage'] },
      { id: 2, name: 'Comprehensive Home', price: 99, coverage: 'Full property protection', features: ['All Dwelling features', 'Personal property', 'Liability coverage'] },
      { id: 3, name: 'Elite Home', price: 159, coverage: 'Complete home security', features: ['All Comprehensive features', 'Identity protection', 'Equipment breakdown'] },
    ],
    life: [
      { id: 1, name: 'Term Life', price: 25, coverage: 'Temporary protection', features: ['10-30 year terms', 'Fixed premiums', 'Death benefit'] },
      { id: 2, name: 'Whole Life', price: 120, coverage: 'Lifetime protection', features: ['Lifetime coverage', 'Cash value', 'Fixed premiums'] },
      { id: 3, name: 'Universal Life', price: 85, coverage: 'Flexible protection', features: ['Lifetime coverage', 'Cash value', 'Flexible premiums'] },
    ],
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    document.getElementById('application-form').scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmitApplication = (e) => {
    e.preventDefault();
    alert(`Thank you for your application for ${selectedPlan.name}! We will contact you shortly.`);
    setSelectedPlan(null);
  };

  return (
    <div className="fintech-container" style={{ padding: '8rem 0 4rem' }}>
      <header className="insurance-header">
        <h1>Insurance Protection</h1>
        <p>Secure your future with our comprehensive insurance plans</p>
      </header>

      <div className="insurance-types">
        {insuranceTypes.map(type => (
          <div 
            key={type.id} 
            className={`insurance-type-card ${activeTab === type.id ? 'active' : ''}`}
            onClick={() => setActiveTab(type.id)}
          >
            <div className="type-icon">{type.icon}</div>
            <h3>{type.name}</h3>
          </div>
        ))}
      </div>

      <div className="plans-container">
        <h2>Available {insuranceTypes.find(t => t.id === activeTab).name} Plans</h2>
        <div className="bento-grid">
          {insurancePlans[activeTab].map(plan => (
            <div key={plan.id} className="bento-box col-span-1 plan-card">
              <h3>{plan.name}</h3>
              <div className="plan-price">${plan.price}<span>/month</span></div>
              <p className="plan-coverage">{plan.coverage}</p>
              <ul className="plan-features">
                {plan.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <button 
                className="select-plan-btn"
                onClick={() => handleSelectPlan({...plan, type: activeTab})}
              >
                Select Plan
              </button>
            </div>
          ))}
        </div>
      </div>

      {selectedPlan && (
        <div id="application-form" className="bento-grid" style={{ marginTop: '3.5rem' }}>
          <div className="bento-box col-span-4 application-form">
            <h2>Apply for {selectedPlan.name}</h2>
            <p className="selected-plan-info">${selectedPlan.price}/month • {selectedPlan.coverage}</p>
            
            <form onSubmit={handleSubmitApplication}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <input type="text" id="fullName" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input type="email" id="email" required />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" required />
                </div>
                <div className="form-group">
                  <label htmlFor="dob">Date of Birth</label>
                  <input type="date" id="dob" required />
                </div>
              </div>
              
              <div className="form-group full-width">
                <label htmlFor="address">Address</label>
                <input type="text" id="address" required />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <input type="text" id="city" required />
                </div>
                <div className="form-group">
                  <label htmlFor="zip">ZIP Code</label>
                  <input type="text" id="zip" required />
                </div>
              </div>
              
              <button type="submit" className="submit-application-btn">
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}

      <footer className="insurance-footer">
<p>
  Need help choosing? 
  <a href="tel:9660236005" class="call-link">Call our experts at +91-9660236005</a>
</p>

      </footer>
    </div>
  );
};

export default Insurance;